const IconAccordionPlus = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0.333008C27.7568 0.333183 35.6658 8.24323 35.666 18C35.6658 27.7568 27.7568 35.6658 18 35.666C8.24323 35.6658 0.333183 27.7568 0.333008 18C0.333184 8.24323 8.24323 0.333184 18 0.333008ZM18 2.33301C9.3478 2.33318 2.33318 9.3478 2.33301 18C2.33318 26.6522 9.3478 33.6658 18 33.666C26.6522 33.6658 33.6658 26.6522 33.666 18C33.6658 9.3478 26.6522 2.33318 18 2.33301ZM18 10.333C18.5522 10.333 18.9998 10.7809 19 11.333V17H24.666C25.2183 17 25.666 17.4477 25.666 18C25.666 18.5523 25.2183 19 24.666 19H19V24.666C19 25.2183 18.5523 25.666 18 25.666C17.4477 25.666 17 25.2183 17 24.666V19H11.333C10.7809 18.9998 10.333 18.5522 10.333 18C10.333 17.4478 10.7809 17.0002 11.333 17H17V11.333C17.0002 10.7809 17.4478 10.333 18 10.333Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconAccordionPlus;
